import {
  type IconDefinition,
  type IconName,
  type IconPrefix,
} from '@fortawesome/fontawesome-svg-core'
import React from 'react'

export const iconInsuranceOff: IconDefinition = {
  icon: [
    14,
    14,
    [],
    '',
    'M16.2227 13.0938C16.2227 13.4492 15.9492 13.75 15.5664 13.75C15.4297 13.75 15.293 13.7227 15.1562 13.5859L-1.00391 0.925781C-1.16797 0.816406 -1.25 0.625 -1.25 0.40625C-1.25 0.078125 -0.976562 -0.25 -0.59375 -0.25C-0.457031 -0.25 -0.320312 -0.195312 -0.210938 -0.0859375L2.25 1.82812L6.98047 -0.140625C7.14453 -0.195312 7.30859 -0.25 7.5 -0.25C7.66406 -0.25 7.82812 -0.195312 7.99219 -0.167969L13.2422 2.01953C13.7344 2.23828 14.0625 2.70312 14.0625 3.25C14.0625 5.92969 13.3242 8.0625 12.2852 9.67578L15.9492 12.5742C16.1133 12.6836 16.2227 12.875 16.2227 13.0938ZM11.2734 8.88281C12.1484 7.37891 12.75 5.46484 12.75 3.25L7.5 1.0625L3.45312 2.75781L11.2734 8.88281ZM7.5 12.4375C8.21094 12.1367 8.97656 11.6445 9.66016 10.9609L10.6992 11.7812C10.2891 12.1914 8.48438 13.75 7.47266 13.75C6.21484 13.75 1.375 10.6602 0.964844 4.15234L2.41406 5.30078C3.04297 8.88281 5.23047 11.5078 7.5 12.4375Z',
  ],
  iconName: 'insurance-off' as IconName,
  prefix: 'flecto' as IconPrefix,
}
